<div class="header-row">
    <form [formGroup]="searchForm" (ngSubmit)="filterItems()">
        <input
            hamInput
            icon="/assets/hamIcons/search-outline.svg"
            formControlName="searchTerm"
            placeholder="{{ 'aumico_text_snippets_table_search_placeholder' | i18next }}"
            (cancel)="resetFilter()"
        />
    </form>
    <ham-button icon="assets/hamIcons/plus-outline.svg" (click)="addNewChecklist()">
        {{ 'aumico_reports_organization_settings_checklist_add_new_button' | i18next }}
    </ham-button>
</div>

<ham-table-with-actions
    [dataSource]="filteredData"
    [pageSize]="10"
    [menuItems]="menuItems"
    [columnClasses]="['hamTextCol', 'hamDateCol', 'hamDateCol', 'hamTextCol']"
    (menuOptionClicked)="onMenuItemClicked($event)"
    (checkBoxSelectionChanged)="onCheckBoxSelectionChanged($event)"
>
    <ng-template hamHeaderCell>
        {{ 'aumico_checklist_management_table_checklist_name' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell>
        {{ 'aumico_checklist_management_table_checklist_created_at' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell>
        {{ 'aumico_checklist_management_table_checklist_last_change' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell>
        {{ 'aumico_checklist_management_table_checklist_modified_by' | i18next }}
    </ng-template>

    <ng-template hamCell let-element> {{ element?.name || '-' }} </ng-template>
    <ng-template hamCell let-element>
        {{ element?.createdAt ? (element.createdAt | dateLocale) : '-' }}
    </ng-template>
    <ng-template hamCell let-element>
        {{ element?.updatedAt ? (element.updatedAt | dateLocale) : '-' }}
    </ng-template>
    <ng-template hamCell let-element> {{ element?.updatedBy || '-' }} </ng-template>

    <ng-template hamMenuButton let-element>
        <span
            hamIconShapes
            icon="assets/hamIcons/copy.svg"
            [variant]="'transparent'"
            [size]="'regular'"
            [type]="'circle'"
            (click)="copyChecklist(element)"
            stopPropagation
        ></span>
    </ng-template>
    <ng-template hamMenuButton let-element>
        <span
            hamIconShapes
            icon="assets/hamIcons/edit-outline.svg"
            [variant]="'transparent'"
            [size]="'regular'"
            [type]="'circle'"
            (click)="editChecklist(element)"
            stopPropagation
        ></span>
    </ng-template>
</ham-table-with-actions>
